module.exports = __webpack_public_path__ + "static/eleven-warriors-vintage-hoodie-2f1b1f578db08782b78b792ee63f7962.webp";